import type { FC, PropsWithChildren } from "react";

import { useChat } from "../providers/chat-provider";

export const ChatScrollWrapper: FC<PropsWithChildren> = ({ children }) => {
  const { handleScroll, scrollableRef } = useChat();

  return (
    <div
      ref={scrollableRef}
      onScroll={handleScroll}
      className="bg-inherit flex-1 relative z-0 min-h-0 min-w-0 overflow-y-auto overflow-x-hidden flex flex-col h-full"
    >
      {children}
    </div>
  );
};
